export default {"src":"/_next/static/media/advanced_predictive_analytics.69c2d742.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};